 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~9a7cfb37","1":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~f1a6f51d","2":"source~/esports-betting-rules-TR~esports-betting-rules-AZ~esports-betting-rules-DA~esports-betting-r~c810e73c","4":"source~virtual-esports-betting-rules-AZ~virtual-esports-betting-rules-EN~virtual-esports-betting-rul~8df6e383","7":"source~bet-details-page~betting-history-page","8":"source~i18n-widgets-en-json","9":"source~i18n-widgets-es-json","12":"source~/esports-betting-rules-TR","13":"source~bet-builder-rules-AZ","14":"source~bet-builder-rules-DE","15":"source~bet-builder-rules-EN","16":"source~bet-builder-rules-ES","17":"source~bet-builder-rules-ES-MX","18":"source~bet-builder-rules-ET","19":"source~bet-builder-rules-FI","20":"source~bet-builder-rules-FR","21":"source~bet-builder-rules-IT","22":"source~bet-builder-rules-JA","23":"source~bet-builder-rules-KA","24":"source~bet-builder-rules-LT","25":"source~bet-builder-rules-LV","26":"source~bet-builder-rules-PL","27":"source~bet-builder-rules-PT-BR","28":"source~bet-builder-rules-RO","29":"source~bet-builder-rules-RU","30":"source~bet-builder-rules-SQ","31":"source~bet-builder-rules-SV","32":"source~bet-builder-rules-TR","33":"source~bet-details-page","34":"source~betting-history-container","35":"source~betting-history-page","36":"source~betting-rules-AZ","37":"source~betting-rules-DA","38":"source~betting-rules-DE","39":"source~betting-rules-EN","40":"source~betting-rules-ES","41":"source~betting-rules-ES-MX","42":"source~betting-rules-FR","43":"source~betting-rules-IT","44":"source~betting-rules-JA","45":"source~betting-rules-PL","46":"source~betting-rules-PT","47":"source~betting-rules-PT-BR","48":"source~betting-rules-RO","49":"source~betting-rules-RU","50":"source~betting-rules-SQ","51":"source~betting-rules-SV","52":"source~betting-rules-TR","53":"source~bonus-info","54":"source~cashout-terms-AR","55":"source~cashout-terms-AZ","56":"source~cashout-terms-DA","57":"source~cashout-terms-DE","58":"source~cashout-terms-EN","59":"source~cashout-terms-ES","60":"source~cashout-terms-ES-MX","61":"source~cashout-terms-ET","62":"source~cashout-terms-FI","63":"source~cashout-terms-FR","64":"source~cashout-terms-IT","65":"source~cashout-terms-JA","66":"source~cashout-terms-KA","67":"source~cashout-terms-KU","68":"source~cashout-terms-LT","69":"source~cashout-terms-LV","70":"source~cashout-terms-PL","71":"source~cashout-terms-PT","72":"source~cashout-terms-PT-BR","73":"source~cashout-terms-RO","74":"source~cashout-terms-RU","75":"source~cashout-terms-SQ","76":"source~cashout-terms-SR","77":"source~cashout-terms-SV","78":"source~cashout-terms-TR","79":"source~esports-betting-rules-AZ","80":"source~esports-betting-rules-DA","81":"source~esports-betting-rules-DE","82":"source~esports-betting-rules-EN","83":"source~esports-betting-rules-ES","84":"source~esports-betting-rules-ES-MX","85":"source~esports-betting-rules-ET","86":"source~esports-betting-rules-FI","87":"source~esports-betting-rules-FR","88":"source~esports-betting-rules-IT","89":"source~esports-betting-rules-JA","90":"source~esports-betting-rules-KA","91":"source~esports-betting-rules-LT","92":"source~esports-betting-rules-LV","93":"source~esports-betting-rules-PL","94":"source~esports-betting-rules-PT","95":"source~esports-betting-rules-PT-BR","96":"source~esports-betting-rules-RO","97":"source~esports-betting-rules-RU","98":"source~esports-betting-rules-SQ","99":"source~esports-betting-rules-SR","100":"source~esports-betting-rules-SV","101":"source~generated-mappings","102":"source~i18n-en-json","103":"source~i18n-es-json","105":"source~settings-page","106":"source~streaming-carousel","107":"source~virtual-esports-betting-rules-AZ","108":"source~virtual-esports-betting-rules-EN","109":"source~virtual-esports-betting-rules-IT","110":"source~virtual-esports-betting-rules-JA","111":"source~virtual-esports-betting-rules-PL","112":"source~virtual-esports-betting-rules-RU","114":"vendors~rc-slider","115":"vendors~react-google-recaptcha","116":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"128b9aebc5270a65a3dd","1":"8ba899dd6f59e12529d3","2":"95aa199dd057a730c652","3":"52eb989790f4ab49c428","4":"ca0f9a1edcc0a4df2927","5":"c11b15ddc67d6b18b8e5","6":"862fe03b1bdc2c8b99c3","7":"4cee803ab4a99275f3e0","8":"e05cee6a6f444e23e6da","9":"a6e4cd00d4a1c4a6c8a1","12":"3630a916259519062bd9","13":"e5e271fd4ec1d4c66290","14":"0a9304215f3ed20d9b42","15":"478af7178929ecf2453f","16":"a5688f6d53e0cbe9e41f","17":"c7b9c0739bfa9cc0c190","18":"c7a1aafd0116ddbfa741","19":"e62e5dc16d1d4c7dbf48","20":"0986dfe4e5a4a7725234","21":"ef4a6fa5df0522ceb06a","22":"4d5919f39a55ceecaacf","23":"83e3d5bc588c6a4f0646","24":"d609dbeb30ead2ec50ba","25":"74ba7d840452e1154c73","26":"3270b130c52fefd963ef","27":"2f1c4f9300533f57acf0","28":"28e8c0251d892a2bc71e","29":"5affc50ee5d17da9662f","30":"c15593e02fa04a3bd8dc","31":"b65c8ec7cc0f0827705c","32":"c148eddc400e7c368d9f","33":"b84d7759afdd2bf2d324","34":"26bdd5987fd1f1d67d7b","35":"b2702328a6c8e3ee089d","36":"609e1cf47d2d5f5f3cf4","37":"35d289024bd5e93b0f82","38":"4ff723b9ca0695882df2","39":"83c07a8a65c88156f362","40":"6b4445d138e5a82f47e6","41":"7a0306aecbcc2a19b36e","42":"8f537057e1dd695707c3","43":"aa96cc0cafbb34298d9f","44":"18e49ac990f859a4bc2e","45":"4a067ca04d3c0a106da9","46":"d7af34c4308d1687c8e9","47":"e013acf4452f010d4825","48":"d9573bf8f6d0849aa751","49":"7d506e0f9e10d8ffc40a","50":"8201ae4f58df42290db1","51":"0ae6a1c4e3f2bf7b7f12","52":"e40d13a20ab177371e3d","53":"3e4cab394b7ae93f34d1","54":"d7a4bcc88ada80c9683e","55":"ba0237892e85bc6f338e","56":"bdd990afd4622e13831a","57":"2c50f7c3fbae9f914aac","58":"88f61c5cedb9f9d51204","59":"65ac28c8349115369425","60":"52abee54f398cb753748","61":"487a509285fb6ccadb65","62":"a2dca8f3d27b0d51c0c9","63":"c3916bffeb9cf41c6333","64":"12abc4053fbda7d854b3","65":"32afa6ba247a9e541373","66":"c2dd1884f283f3b8b7b7","67":"4afff697ac373037908e","68":"09b2a9c24959006384f4","69":"5ae85ff8a55c9773c291","70":"4f65bb10bd5d8c0a2846","71":"08c462a20d9fcabb9a0f","72":"53d8ec1edf7fa0c4c247","73":"be07eb44178e7ffa17e2","74":"38cf0e1dabfe57768f87","75":"39cd791dd98406957d25","76":"de556d89448c8caf2847","77":"73661582b1734ed9c8c2","78":"fd469e5dea4fdf378dc8","79":"9943abe32c3cbbc769fc","80":"2909120afb01da501962","81":"a1a177ee5000ab0aafcc","82":"7b16f4eb356a375f291f","83":"a815a8dcd68b371748d3","84":"97fcf51926a651a68615","85":"b0abf4c9c2f8037e4d66","86":"42f54548ff9ac53d3971","87":"efb68a34e30b06bdd718","88":"2d712af095eee223a8e7","89":"6dd32170b72637231015","90":"7996ba2e6a2edd3dcba3","91":"19004af6231a527563c3","92":"b894dd9a78bcb64c813b","93":"b3b1cdf584c3f4b79ea2","94":"6c6768147cd18689334b","95":"20f081ef252d024f510a","96":"f942a2a9de704f448c12","97":"77c1ddaf1c62788cc804","98":"aa45e7930fbac5abecec","99":"530ec84556e1fd18492f","100":"d0727c25164840cb1a5f","101":"0eaff4385dea29a85e6c","102":"3bec79c9caf7ec28a8a9","103":"2decc9a74b52b05240c3","105":"7e61763b34764c8fed18","106":"cfaf556ed9db13cbeee8","107":"84156db1d40fadc085c8","108":"25f3d14f36676e9d9045","109":"91b1db6ffc39c2ac6a55","110":"2562097e18b924b505d1","111":"b6cbe5de3172f0777c0a","112":"0d98db4b0a9836294640","114":"fcd1514821daa17700a2","115":"75e84fd2d76d2f2cda27","116":"889b917bf131b5827a5b","117":"9c50dc718246544a4fd4","118":"5219fa99d17cfc2a246f","119":"136342b94d87a60c9838","120":"6efe9243f8aba6673f9f","121":"8e8f9be0bc01bdcac757","122":"e1988e357bcf24217bbc","123":"d1ea6d042f8a16ff5fb9","124":"13805f7522af16ff76fb","125":"8bbdb78b18a2ca368c58","126":"8faec62880d0a5ba273f","127":"1e414ed04bf749f1795b","128":"cae2d72a7b971be7a7ea","129":"74dce235eea39c737031","130":"bf4ebbc63f4f534b1efa","131":"3088e4664514753de4f6","132":"8681c1ac2e0288f8e6aa","133":"dda1710ac46e89f91175","134":"4d4f4b5c304bc591dc20","135":"31431ffb291e9863736a","136":"7a5be84060fa973138ad","137":"d90a30cd5c2117ae88cb","138":"585aaf1b9b561822d1bb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
